import "./App.scss";
import "./index.scss";
import AppRouter from "./infraestructure/routes";
import moment from "moment";

type Status = "authenticated" | "no-authenticated";
let status: Status = "authenticated";

function App() {
  moment.locale("es");
  return (
    <div>
      <AppRouter />
    </div>
  );
}

export default App;
